import {
  getCurrentLangText,
  getLocalTime,
  getNeedManageSites,
} from '../../../../lib';
import {
  CommonStatusStep,
  DownloadObjectType,
  IDownLoadMenu,
  IDownLoadVersionMenu,
} from '../../../../model/api-modules';
import { getEngineName } from './download-version-form';
import { getTypeName } from './download-form';
import getFormatMessage from '../../../../locales/get-format-message';

import { AutoAntTable } from '../../../../components/auto-ant-table';
import {
  CommonButton,
  CommonButtonGroup,
} from '../../../../components/button/main';
import { ISiteIDownLoadMenu } from '../download-items';

import { CustomPopover } from '../../../../components/custom-popover';
import { renderValidateStatusCell } from '../../lib/columns';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../../store/reducers';

interface IProps {
  readonly onChange: () => void;
  readonly loading: boolean;
  readonly downLoadList: IDownLoadMenu[];
  readonly allSiteList: ISiteIDownLoadMenu;
  readonly selectedRowKeys: number[];
  readonly onSelectChange: (
    keys: readonly number[] | readonly string[]
  ) => void;
  readonly onEdit: (record: IDownLoadMenu) => void;
  readonly onView: (record: IDownLoadMenu) => void;
  readonly onWhite: (record: IDownLoadMenu) => void;
  readonly onDel: (record: IDownLoadMenu) => void;
}
export const DownloadTable = (props: IProps) => {
  const { allSiteList, selectedRowKeys, onSelectChange } = props;
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  const renderDefaultOperate = (
    record: IDownLoadMenu,
    allSiteList: ISiteIDownLoadMenu,
    onView: (record: IDownLoadMenu) => void,
    onEdit: (record: IDownLoadMenu) => void,
    onWhite: (record: IDownLoadMenu) => void,
    onDel: (record: IDownLoadMenu) => void
  ): React.ReactNode => {
    const isEnable = Object.values(allSiteList).some(
      (siteDownloadList: IDownLoadMenu[]) =>
        siteDownloadList.some(
          (downloadItem) =>
            downloadItem.Name === record.Name &&
            downloadItem.Status === CommonStatusStep.Resolve
        )
    );
    return (
      <CommonButtonGroup>
        <CommonButton type="link" onClick={() => onView(record)}>
          查看
        </CommonButton>

        <CommonButton type="link" onClick={() => onEdit(record)}>
          {getFormatMessage('edit')}
        </CommonButton>
        <CommonButton type="link" onClick={() => onWhite(record)}>
          {getFormatMessage('white_list')}
        </CommonButton>
        <CommonButton
          type="link"
          danger
          disabled={isEnable}
          onClick={() => onDel(record)}
        >
          {getFormatMessage('delete')}
        </CommonButton>
      </CommonButtonGroup>
    );
  };
  const isWhite = (record: IDownLoadMenu): boolean => {
    const isOtherWhite = Object.values(allSiteList).some(
      (siteDownloadList: IDownLoadMenu[]) =>
        siteDownloadList.some(
          (downloadItem) =>
            downloadItem.Name === record.Name &&
            !!downloadItem.StudioWhitelistArray?.length
        )
    );
    return isOtherWhite;
  };
  const columns: any = [
    {
      title: getFormatMessage('name_uppercase'),
      dataIndex: 'Name',
      key: 'Name',
      fixed: 'left',
    },
    {
      title: getFormatMessage('status'),
      dataIndex: 'Status',
      key: 'Status',
      render: (_text: any, record: IDownLoadMenu) => {
        const statusMap = getNeedManageSites().reduce<
          Record<string, CommonStatusStep>
        >((acc, site) => {
          acc[site] =
            allSiteList[site].find((item) => item.Name === record.Name)
              ?.Status || CommonStatusStep.Pending;
          return acc;
        }, {});
        const whiteMap = getNeedManageSites().reduce<Record<string, boolean>>(
          (acc, site) => {
            const match = allSiteList[site].find(
              (item) => item.Name === record.Name
            );
            acc[site] = match ? isWhite(match) : false;
            return acc;
          },
          {}
        );
        return renderValidateStatusCell(statusMap, whiteMap);
      },
    },
    {
      title: getFormatMessage('type_uppercase'),
      dataIndex: 'Type',
      key: 'Type',
      render: (type: DownloadObjectType) => getTypeName(type),
    },
    {
      title: '下载物级别',
      dataIndex: 'ParentTag',
      key: 'ParentTag',
      render: (ParentTag: string) => {
        return ParentTag ? '二级下载物' : '一级下载物';
      },
    },
    {
      title: getFormatMessage('description'),
      dataIndex: 'Description',
      key: 'Description',
      render: (text: string) => {
        return (
          <CustomPopover content={getCurrentLangText(text)}>
            <div className="ellipsis">{getCurrentLangText(text)}</div>
          </CustomPopover>
        );
      },
    },
    {
      title: getFormatMessage('properties'),
      dataIndex: 'VersionItem',
      key: 'VersionItem',
      render: (VersionItem: IDownLoadVersionMenu) => {
        const engineName = VersionItem?.EngineJson
          ? getEngineName(VersionItem.EngineJson)
          : '-';
        return <span>{engineName}</span>;
      },
    },
    {
      title: getFormatMessage('create_time_local'),
      dataIndex: 'CreateTime',
      key: 'CreateTime',
      render: (record: string) => (
        <div>
          <div>
            {getLocalTime(
              record as unknown as Date,
              userInfo?.UserSettings?.Timezone
            )}
          </div>
        </div>
      ),
      sorter: (a: { CreateTime: Date }, b: { CreateTime: Date }) => {
        return (
          new Date(a.CreateTime).getTime() - new Date(b.CreateTime).getTime()
        );
      },
    },
    {
      title: getFormatMessage('last_modify_time_local'),
      dataIndex: 'ModifyTime',
      key: 'ModifyTime',
      render: (val: string, record: IDownLoadMenu) => (
        <div>
          <div>
            {getLocalTime(
              record.ModifyTime as unknown as Date,
              userInfo?.UserSettings?.Timezone
            )}
          </div>
          <div>
            {record.ModifierUserID || record.ModifierID || record.CreatorID}
          </div>
        </div>
      ),
    },
    {
      title: getFormatMessage('operate'),
      key: 'action',
      fixed: 'right',

      render: (_text: string, record: IDownLoadMenu) =>
        renderDefaultOperate(
          record,
          allSiteList,
          props.onView,
          props.onEdit,
          props.onWhite,
          props.onDel
        ),
    },
  ];
  return (
    <AutoAntTable
      className="download-table"
      loading={props.loading}
      dataSource={props.downLoadList || []}
      columns={columns}
      rowSelection={{ selectedRowKeys, onChange: onSelectChange }}
      configFilter={{
        filters: [
          {
            type: 'search',
            name: 'Name',
            place: 'right',
            placeholder: '请输入名称搜索',
          },
        ],
      }}
    />
  );
};
